export const HAS_VIDEO_ATTR = 'hasVideo';

export const IS_VIDEO_ATTR = 'isVideo';

export const IS_EXTERNAL_LINK_ATTR = 'isExternalLink';
